<template>
	<div style="padding: 0 20px 50px 20px;">
		<div class="operation-box f-cb">
			<el-button type="primary" class="f-fl" style="margin-right:20px ;" @click="$router.push({ path: 'genre' })">品类码标注册</el-button>
			<!--<el-select v-model="select" slot="prepend" placeholder="请选择" class="f-fl" style="width: 26%" @change="section">
				<el-option v-for="item in selectfata" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>-->
			<el-input placeholder="请输入内容" @keyup.enter.native="inquire" v-model.trim="precisecontext" class="input-with-select f-fl" style="width: 45%;">
				<el-button slot="append" icon="el-icon-search" @click="inquire"></el-button>
			</el-input>

		</div>
		<section class="result-box">
			<el-table :data="tableData" style="width: 100%;min-height: 480px;" v-loading="Loading">
				<el-table-column prop="name" label="品类码标 ">
				</el-table-column>
				<el-table-column prop="analysis" label="品类名称  ">
				</el-table-column>
				<el-table-column prop="starttime" label="IDcode">
				</el-table-column>
				<!--<el-table-column prop="endtime" label="到期时间 " >
				</el-table-column>-->
				<!--<el-table-column prop="registrationtime" label="解析地址  ">
				</el-table-column>-->
				<el-table-column prop="stateurl" label="解析地址 ">

				</el-table-column>
				<el-table-column prop="state" label="解析地址状态 ">

				</el-table-column>
				<el-table-column prop="type" label="操作  ">

					<template slot-scope="scope">
						<!--{{scope.row.operationList}}-->

						<el-button type="text" size="mini" @click="setanalysis({row:scope.row})">设置解析</el-button>
						<el-button type="text" size="mini" @click="particulars(scope.row.id,scope.row.name)">详情</el-button>
						<!--<el-button size="small" @click="handleDelete(scope.$index, scope.row,item.operationType)" v-for="(item,index) in scope.row.operationList">{{item.operation}}</el-button>-->
						<!--<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
					</template>
				</el-table-column>
				<!--<el-table-column prop="" label="查看详情  ">
					<template slot-scope="scope">
						<el-button type="text" size="mini" @click="particulars(scope.row.id)">查看详情</el-button>

					</template>

				</el-table-column>-->
			</el-table>
		</section>

		<div class="pagination-box">
			<!--<el-button type="primary" size="mini" >主要按钮</el-button>-->
			<el-pagination background layout="prev, pager, next,slot,total,sizes" :total="pagination.total" :page-size="10" prev-text=" 上一页 " :page-sizes="[10]" next-text="下一页" @prev-click="prev" @next-click="next" @current-change="current">
				<!--<el-button type="primary" size="mini" >主要按钮</el-button>-->

				<!--<span style="    margin-right: 10px;font-weight: 400; color: #606266;">
				共 222 条
			</span> -->
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				Loading: false,
				input3: '',
				input4: '',
				input5: '',
				precisecontext: '',
				select: 'all',
				selectfata: [{
						value: 'all',
						label: '全部'
					},
					{
						value: 100,
						label: '正常'
					}, {
						value: '-6',
						label: '审核期退款已停用'
					}, {
						value: '-5',
						label: '未续费已停用'
					}, {
						value: '-4',
						label: '未缴费已停用'
					}, {
						value: '-3',
						label: '已禁用'
					}, {
						value: '-2',
						label: '已过期'
					}, {
						value: 2,
						label: '注册待付款'
					}, {
						value: 4,
						label: '已过户'
					}, {
						value: 99,
						label: '审核期'
					},

				],
				tableData: [],

				pagination: {
					total: 0,
					present: 1,

				}
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
//				console.log(vm.$store)
				if(!vm.$store.state.commonalityData.IdcodeUserId) {
//					vm.$store.commit('resist');

					next('genreslip') ;
				}
			})
		},

		created() {

			//			if(this.$store.state.commonalityData.IdcodeUserId === '') {
			//				this.$alert('请完善信息再使用此功能', '提示', {
			//					confirmButtonText: '完善信息',
			//					callback: action => {
			//						if(action === 'confirm') {
			//							this.$router.push({
			//								path: 'perfect'
			//							})
			//						} else {
			//							this.$router.push({
			//								path: 'home'
			//							})
			//
			//						}
			//					}
			//				});
			//			} else {
			this.Datas();
			//			}
		},
		methods: {
			Datas() {
				this.Loading = true;
				this.$http.get(this.$api + '/categoryApply/getCategoryListByUnitID', {
					params: {
						//						identification: this.precisecontext,
						//						identificationStatus: this.select,
						categoryObject: this.precisecontext,
						pageIndex: this.pagination.present,
						pageSize: '10'
					}
				}).then(res => {
					if(res.body.result === 1) {
						this.pagination.total = res.body.queryResult;
						this.tableData = res.body.entity.map((item) => {
							//		categoryIDcode					console.log(typeof '"' + item.categoryregId + '"')
							return {
								name: item.categoryObject,
								analysis: item.categoryName,
								starttime: item.categoryIDcode,
								registrationtime: item.createDate,
								stateurl: item.analyUrl != null ? item.analyUrl : item.pendingauditurl,
								state: this.typetransition({
									index: item.analyUrlStatus === null ? '' : item.analyUrlStatus,
									url: item.analyUrl === null ? '' : item.analyUrl,
									twourl: item.pendingauditurl === null ? '' : item.pendingauditurl
								}),
								id: item.categoryregId,
								operationList: item.operationList,
								payment_order: item.payment_order
							}

						})
					} else {
						this.tableData = [];
						this.pagination.total = 0;
					}
					this.Loading = false;
				}, rej => {
					this.$message.error('数据连接失败，请尝试刷新');

				})

			},
			typetransition({
				index,
				url,
				twourl
			}) {
				//				if(index != '') {
				//             	<c:choose>
				//  <c:when test="${(item.UrlExamineStatus==0||item.UrlExamineStatus==null)&& empty item.GOTOURL&&empty item.PENDINGAUDITURL}">
				//      未设置解析地址
				//  </c:when>
				//  <c:when test="${item.UrlExamineStatus==-1}">
				//      审核失败
				//  </c:when>
				//  <c:when test="${item.UrlExamineStatus==0&&not empty item.PENDINGAUDITURL}">
				//      审核中
				//  </c:when>
				//  <c:when test="${item.UrlExamineStatus>0&&item.UrlExamineStatus<100}">
				//      审核中
				//  </c:when>
				//  <c:when test="${not empty item.GOTOURL&&empty item.PENDINGAUDITURL}">
				//      审核完成
				//  </c:when>
				//</c:choose>

				if(!index && !twourl && !url) {
					return '未设置解析地址'
				} else if(index === -1) {
					return '审核失败'
				} else if(index === 0 && !url) {
					return '审核中'
				} else if(twourl && url && index === 0) {
					return '审核中'

				} else if(index > 0 && index < 100) {
					return '审核中'
				} else if(url != '') {
					return '审核完成'
				}

				//				} else {
				//					return false;
				//				}

			},

			prev(val) {
				//				console.log(val)
				this.pagination.present = val;
				this.Datas();

			},
			next(val) {
				//				console.log(val)
				this.pagination.present = val;
				this.Datas();

			},
			current(val) {
				this.pagination.present = val;
				this.Datas();
			},
			inquire() {
				this.pagination.present = 1;
				this.Datas();

			},
			particulars(id, maname) {
				//				console.log(maname)
				this.$router.push({
					path: 'genrelistdetails',
					query: {
						id: id,
						ma: maname
					}
				})
			},
			section() {
				this.pagination.present = 1;

				this.Datas();

			},
			setanalysis({
				row
			}) {

				//				console.log(row.starttime)

				this.$router.push({
					name: 'genreanalysis',
					query: {
						id: row.id,
						idcode: row.starttime,
						maid: row.name
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.operation-box {
		/*border: solid red 1px;*/
		width: 60%;
		/*text-align: left;*/
		/*margin: 0 auto;*/
		margin-top: 50px;
	}
	
	.result-box {
		/*border: solid red 1px;*/
		padding-top: 40px;
	}
	
	.pagination-box {
		margin-top: 50px;
	}
	
	.labClass {
		text-align: center;
	}
</style>